import {OfferCard, GoMap} from './offer-card/customElement.js';
import {OfferSerp, MortgageMiniCalculator, SeoDistanceBreadcrumb} from './offers-serp/customElement.js';

const urls = [
    '/finance/cian-cd-partners-badge/widget.js',
    '/finance/content-distribution-maps-elements/widget.js',
    '/finance/listing-photo-gallery/widget.js',
    '/finance/content-distribution-fotogallery/widget.js',
    '/finance/content-distribution-calculator/widget.js',
    '/finance/content-distribution/customization.js',
    '/finance/content-distribution-mini-fotogallery/widget.js',
    '/finance/builder-info-block-mini/widget.js',
    '/finance/content-distribution-call-tracking-button/widget.js',
    '/finance/call-tracking-button-light/widget.js',
    '/finance/content-distribution-jk-search/widget.js',
    '/finance/price-history/widget.js',
    '/finance/offer-card-mini/widget.js',
    '/finance/breadcrumbs/widget.js',
    '/finance/cian-tooltip/widget.js',
    '/finance/mortgage-button/widget.js',
    '/finance/cian-favorites-component/widget.js',
    '/finance/cian-shahe-component/widget.js',
    '/finance/cian-callback-button/widget.js',
    '/finance/content-distribution-search-link/widget.js',
];

urls.forEach((url) => {
    if (!document.querySelector(`script[src*="${url}"]`)) {
        const scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        scriptElement.charset = 'UTF-8';
        scriptElement.src = `//cdn${Math.round(1 + Math.random() * 8)}.cian.site${url}`;
        document.head.appendChild(scriptElement);
    }
});

if (!customElements.get('cian-content-offer-card')) {
    customElements.define('cian-content-offer-card', OfferCard)
}

if (!customElements.get('cian-content-serp-card')) {
    customElements.define('cian-content-serp-card', OfferSerp);
}
if (!customElements.get('mortgage-mini-calculator')) {
    customElements.define('mortgage-mini-calculator', MortgageMiniCalculator);
}
if (!customElements.get('seo-distance-breadcrumb')) {
    customElements.define('seo-distance-breadcrumb', SeoDistanceBreadcrumb);
}

if (!customElements.get('go-to-map-button')) {
    customElements.define('go-to-map-button', GoMap);
}

if (!customElements.get('cian-content-seller-block')) customElements.define('cian-content-seller-block', class extends HTMLElement {

});
if (!customElements.get('mortgage-button-test')) customElements.define('mortgage-button-test', class extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', () => {
            const customEvent = new CustomEvent('FILL_ANKETA', {bubbles: true});
            this.dispatchEvent(customEvent);
        })
    }
});
